(function () {
  var holders = document.querySelectorAll('[data-wd-random-grid]');
  if (!holders.length) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cur = (window.Shopify && Shopify.currency) || { active: 'USD', rate: '1.0' };
  var lang = ((document.documentElement.lang || (window.Shopify && Shopify.locale) || 'en') + '').toLowerCase();
  var KEY = 'wd_rg_v3_' + lang;
  var TTL = 30 * 60 * 1000;
  var L = {
    he: { add: 'הוספה לסל', added: 'נוסף', err: 'נסו שוב' },
    de: { add: 'In den Warenkorb', added: 'Hinzugefügt', err: 'Erneut versuchen' },
    fr: { add: 'Ajouter au panier', added: 'Ajouté', err: 'Réessayer' },
    ar: { add: 'أضف إلى السلة', added: 'تمت الإضافة', err: 'حاول مرة أخرى' },
    ja: { add: 'カートに追加', added: '追加しました', err: 'もう一度お試しください' },
    ru: { add: 'В корзину', added: 'Добавлено', err: 'Повторите попытку' },
    zh: { add: '加入購物車', added: '已加入', err: '請再試一次' }
  };
  var LABELS = L[lang] || L[lang.split('-')[0]] || { add: 'Add to cart', added: 'Added', err: 'Try again' };

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function slim(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v) return null;
    return {
      id: v.id,
      title: p.title,
      handle: p.handle,
      image: p.images && p.images.length ? p.images[0].src.split('?')[0] : '',
      price: (parseFloat(v.price) * parseFloat(cur.rate || 1)).toFixed(2)
    };
  }

  function fetchPage(page) {
    return fetch(root + 'collections/all/products.json?limit=50&page=' + page)
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d.products || []).map(slim).filter(Boolean); });
  }

  function load() {
    try {
      var c = JSON.parse(localStorage.getItem(KEY));
      if (c && Date.now() - c.t < TTL && c.cur === cur.active && c.p && c.p.length >= 8) return Promise.resolve(c.p);
    } catch (e) {}
    var page = Math.floor(Math.random() * 52) + 1;
    return fetchPage(page).then(function (p) {
      return p.length >= 8 ? p : fetchPage(1);
    }).then(function (p) {
      if (p.length) {
        try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), cur: cur.active, p: p })); } catch (e) {}
      }
      return p;
    });
  }

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  /* Right-sized product photos: the original upload is ~1080px, the card shows ~165-300px. */
  function sized(url, w) { return esc(url) + '?width=' + w; }

  function card(p) {
    var img = p.image
      ? '<img src="' + sized(p.image, 400) + '" srcset="' + sized(p.image, 200) + ' 200w, ' + sized(p.image, 400) + ' 400w, ' + sized(p.image, 800) + ' 800w" sizes="(min-width: 990px) 18vw, (min-width: 750px) 30vw, 45vw" alt="' + esc(p.title) + '" loading="lazy" width="400" height="400" style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;">'
      : '<div style="background:#f0f0f0;width:100%;height:100%;position:absolute;"></div>';
    return '<li class="grid__item" style="list-style:none;"><div class="card-wrapper product-card-wrapper wd-rg-card">' +
      '<a href="' + root + 'products/' + esc(p.handle) + '" class="wd-rg-link" style="text-decoration:none;display:block;">' +
      '<div class="wd-rg-media" style="padding-bottom:100%;position:relative;overflow:hidden;">' + img + '</div>' +
      '<div class="wd-rg-info"><p class="wd-rg-title">' + esc(p.title) + '</p>' +
      '<p class="wd-rg-price">' + p.price + ' ' + esc(cur.active) + '</p></div></a>' +
      '<div class="quick-add"><button type="button" class="quick-add__submit button button--secondary wd-rg-add" data-variant="' + p.id + '">' + LABELS.add + '</button></div>' +
      '</div></li>';
  }

  function refreshCartBubble() {
    fetch(root + '?section_id=cart-icon-bubble').then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      var n = d.querySelector('.shopify-section');
      var t = document.getElementById('cart-icon-bubble');
      if (n && t) t.innerHTML = n.innerHTML;
    }).catch(function () {});
  }

  function bindAdd(grid) {
    grid.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.wd-rg-add') : null;
      if (!b || b.disabled) return;
      b.disabled = true;
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(b.getAttribute('data-variant')), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        b.textContent = LABELS.added;
        refreshCartBubble();
        setTimeout(function () { b.textContent = LABELS.add; b.disabled = false; }, 2200);
      }).catch(function () {
        b.textContent = LABELS.err;
        b.disabled = false;
      });
    });
  }

  var pending = null;
  holders.forEach(function (h) {
    var grid = document.getElementById(h.getAttribute('data-wd-random-grid'));
    var count = parseInt(h.getAttribute('data-count') || '8', 10);
    if (!grid) return;
    grid.style.visibility = 'hidden';
    pending = pending || load();
    pending.then(function (all) {
      if (!all || !all.length) { grid.style.visibility = 'visible'; return; }
      grid.innerHTML = shuffle(all.slice()).slice(0, count).map(card).join('');
      bindAdd(grid);
      grid.style.visibility = 'visible';
    }).catch(function () { grid.style.visibility = 'visible'; });
  });
})();
